import {
  Toast,
  Button,
  Form,
  Field,
  Divider,
  Uploader,
  Picker,
  Popup,
  DatetimePicker,
  Image as VanImage,
  List,
  Cell,
  CellGroup,
  Col,
  Row,
  Dialog,
  RadioGroup,
  Radio,
  ImagePreview,
  Tab,
  Tabs,
  SubmitBar,
  Checkbox,
  CheckboxGroup,
  Tag,
  Tabbar,
  TabbarItem,
  Icon,
  Grid,
  GridItem,
  Search,
  Calendar,
  NavBar,
  DropdownMenu,
  DropdownItem
} from "vant";
let vantUIs = [
  Toast,
  Button,
  Form,
  Field,
  Divider,
  Uploader,
  Picker,
  Popup,
  DatetimePicker,
  VanImage,
  List,
  Cell,
  CellGroup,
  Col,
  Row,
  Dialog,
  RadioGroup,
  Radio,
  ImagePreview,
  Tab,
  Tabs,
  SubmitBar,
  Checkbox,
  CheckboxGroup,
  Tag,
  Tabbar,
  TabbarItem,
  Icon,
  Grid,
  GridItem,
  Search,
  Calendar,
  NavBar,
  DropdownMenu,
  DropdownItem
];
export default {
  install(Vue) {
    vantUIs.forEach(vantUI => [Vue.use(vantUI)]);
  }
};
